import "dayjs/locale/ar-sa";
import "dayjs/locale/am";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  Accordion,
  AccordionDetails,
  Box,
  Divider,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";
import { FormikTextField } from "../../../components/Layout/FormikTextField";
import { BrokerNameAutocomplete } from "./BrokerNameAutocomplete";

import {
  ProfessionalTypes,
  Employee,
  CurrencyTypes,
  EducationLevel,
} from "../types/processTypes";
import { useAppSelector } from "../../../app/hooks";
import { selectPreference } from "../../preferences/preferencesSlice";

interface ExperienceTabProps {
  formikData: FormikProps<Employee>;
}
export const MoreCV = ({ formikData }: ExperienceTabProps) => {
  const { t } = useTranslation();
  const { t: te } = useTranslation("enums");
  const { locale } = useAppSelector(selectPreference);

  return (
    <Box>
      <Accordion
        elevation={2}
        sx={{
          borderRadius: 2,
          overflow: "hidden",
          "&:before": { display: "none" },
        }}
        expanded
      >
        {/* <StyledAccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="h6" component="div">
            More CV Data
          </Typography>
        </StyledAccordionSummary> */}
        <AccordionDetails sx={{ p: { xs: 2, md: 3 }, pt: { xs: 2, md: 2.5 } }}>
          <Grid container spacing={2}>
            <Grid item md={4} xs={12}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale={locale}
              >
                <DatePicker
                  label={t("applicationDate")}
                  views={["year", "month", "day"]}
                  minDate={new Date("1920-01-01")}
                  disableMaskedInput
                  inputFormat="DD-MMM-YYYY"
                  value={formikData.values.additionalData?.documentReceivedDate}
                  onChange={(value) => {
                    formikData.setFieldValue(
                      "additionalData.documentReceivedDate",
                      value,
                      true,
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      id="applicationDate"
                      sx={{
                        mt: 1,
                      }}
                      fullWidth
                      size="small"
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item md={4} xs={12}>
              <FormikTextField
                formikKey="additionalData.appliedProfession"
                select
                label={te("applied") + " " + te("profession")}
              >
                {Object.keys(ProfessionalTypes).map((option) => (
                  <MenuItem key={option} value={option as string}>
                    {te(option)}
                  </MenuItem>
                ))}
              </FormikTextField>
            </Grid>
            {/* <Divider variant="middle" sx={{ mt: 2, mb: 2, backgroundColor: "rgba(69, 90, 100, 0.08)" }} />  */}

            <Grid item md={4} xs={12}>
              <FormikTextField
                formikKey="education.educationLevel"
                select
                label="Education Level"
              >
                {Object.keys(EducationLevel).map((option) => (
                  <MenuItem key={option} value={option as string}>
                    {te(option)}
                  </MenuItem>
                ))}
              </FormikTextField>
            </Grid>
            <Grid item md={4} xs={12}>
              <FormikTextField
                formikKey="additionalData.numberOfChildren"
                label={t("numberOfChildren")}
                type="number"
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <FormikTextField
                formikKey="additionalData.height"
                label={t("height") + "(" + t("meter") + ")"}
              />
            </Grid>
            <Grid item md={2} xs={12}>
              <FormikTextField
                formikKey="additionalData.weight"
                label={t("weight") + "(" + t("kg") + ")"}
              />
            </Grid>

            <Grid item md={4} xs={12}>
              <Stack direction="row">
                <FormikTextField
                  formikKey="additionalData.salary"
                  label={t("salary")}
                  type="number"
                  sx={{ mr: 0.3, mt: 1 }}
                />
                <FormikTextField
                  formikKey="additionalData.currency"
                  select
                  label={te("currency")}
                >
                  {Object.keys(CurrencyTypes).map((option) => (
                    <MenuItem key={option} value={option as string}>
                      {te(option)}
                    </MenuItem>
                  ))}
                </FormikTextField>
              </Stack>
            </Grid>
            <Grid item md={4} xs={12}>
              <FormikTextField
                formikKey="address.telephone"
                label={t("employeeTelephone")}
              />
            </Grid>
            {/* <Grid item md={4} xs={12}>
              <FormikTextField
                formikKey="address.alternateTelephone"
                label={t("alternateTelephone")}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <FormikTextField
                formikKey="address.streetAddress"
                label={t("address")}
              />
            </Grid> */}

            <Grid item xs={12}>
              <Divider textAlign="left">
                <Typography
                  variant="overline"
                  sx={{
                    fontWeight: 700,
                    color: "primary.main",
                    letterSpacing: 2,
                  }}
                >
                  Contact Information
                </Typography>
              </Divider>
            </Grid>

            <Grid item md={4} xs={12}>
              <FormikTextField
                formikKey="contactPerson.displayName"
                label="Contact Name"
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <FormikTextField
                formikKey="contactPerson.address.telephone"
                label={t("contactTelephone")}
              />
            </Grid>
            {/* <Grid item md={4} xs={12}>
              <FormikTextField
                formikKey="contactPerson.address.streetAddress"
                label="Contact Address"
              />
            </Grid> */}
            <Grid item md={4} xs={12}>
              <BrokerNameAutocomplete formikProps={formikData} />
            </Grid>
            <Grid item md={4} xs={12}>
              <FormikTextField
                formikKey="contactPerson.address.alternateTelephone"
                label="Broker Telephone"
              />
            </Grid>
            {/* <Grid item xs={8}>
              <FormikTextField
                formikKey="additionalData.notes"
                label={t("remark")}
              />
            </Grid> */}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
